import DashboardItem from "../components/Dashboard/DashboardItem";
import DashboardAlerts from "../components/Dashboard/DashboardAlerts";
import DashboardCustomers from "../components/Dashboard/DashboardCustomers";
import {
  alerts,
  changes,
  devices,
  healthStatus,
  incidents,
  nonStandardChanges,
  servers,
  serversOffline,
  standardChanges,
  workstations,
} from "../endpoints";
import useFetch from "../hooks/useFetch";
import Incidents from "../assets/icons/Incidents.svg";
import Devices from "../assets/icons/Devices.svg";
import Workstations from "../assets/icons/Workstations.svg";
import Servers from "../assets/icons/Servers.svg";
import Health from "../assets/icons/Health.svg";
import Alert from "../assets/icons/Alert.svg";
import Offline from "../assets/icons/Offline.svg";
import Changes from "../assets/icons/Changes.svg";
// import DomainScanner from "../components/DomainScanner";

interface incident {
  number: string;
}
interface change {
  number: string;
}
interface standardChange {
  number: string;
}
interface nonStandardChange {
  number: string;
}
interface alert {
  date: string;
}
interface device {
  id: string;
}
interface workstation {
  id: string;
}
interface server {
  id: string;
}
interface serveroffline {
  id: string;
}
interface health {
  id: string;
}

const DashboardLayout = () => {
  // const { data: alertsData } = useFetch<alert>(alerts);
  const { data: incidentsData } = useFetch<incident>(incidents);
  const { data: changesData } = useFetch<change>(changes);
  const { data: standardChangesData } =
    useFetch<standardChange>(standardChanges);
  const { data: nonStandardChangesData } =
    useFetch<nonStandardChange>(nonStandardChanges);
  // const { data: devicesData } = useFetch<device>(devices);
  // const { data: workstationsData } = useFetch<workstation>(workstations);
  // const { data: serversData } = useFetch<server>(servers);
  // const { data: serversofflineData } = useFetch<serveroffline>(serversOffline);
  // const { data: healthstatusData } = useFetch<health>(healthStatus);

  return (
    <div className="overflow-hidden w-full">
      {/* Header */}
      <div>
        <div className="flex justify-between">
          {/* Header Text */}
          <div>
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
              <h1 className="font-bold text-3xl sm:text-4xl">Dashboard</h1>
            </div>
            <p className="mt-4">
              Hier een overzicht van alle Dashboard nummers
            </p>
          </div>
        </div>
        {/* Top side */}
        <div className=" w-full flex flex-row items-start justify-evenly">
          <div className="grid grid-cols-2 gap-4">
            {/* <DashboardItem
              title="Devices"
              count={devicesData?.length}
              description="Devices"
              imageSrc={Devices}
            />
            <DashboardItem
              title="Workstations"
              count={workstationsData?.length}
              description="Workstations"
              imageSrc={Workstations}
            />
            <DashboardItem
              title="Servers"
              count={serversData?.length}
              description="Servers"
              imageSrc={Servers}
            /> */}
            <DashboardItem
              title="Open incidents"
              count={incidentsData?.length}
              description="Open incidenten"
              imageSrc={Incidents}
            />

            <DashboardItem
              title="Standard changes"
              count={standardChangesData?.length}
              description="Standard"
              imageSrc={Changes}
            />

            {/* <DashboardItem
              title="Health status"
              count={healthstatusData?.length}
              description="Health status"
              imageSrc={Health}
            />
            <DashboardItem
              title="Alerts"
              count={alertsData?.length}
              description="Current alerts"
              imageSrc={Alert}
            />
            <DashboardItem
              title="Servers offline"
              count={serversofflineData?.length}
              description="Offline servers"
              imageSrc={Offline}
            /> */}
            <DashboardItem
              title="Open changes"
              count={changesData?.length}
              description="Open changes"
              imageSrc={Changes}
            />
            <DashboardItem
              title="Non standard changes"
              count={nonStandardChangesData?.length}
              description="Non standard"
              imageSrc={Changes}
            />
          </div>
          <DashboardCustomers />
        </div>

        {/* Bottom side */}
        <div className="flex">
          {/* <DashboardAlerts /> */}
          
        </div>
      </div>
    </div>
    // <div className="flex flex-col h-full overflow-x-hidden">

    // </div>
  );
};

export default DashboardLayout;
